import React from 'react'
import { About3 } from '../components/About/About3'
// import Team from "../components/Team/Team";
// import About from "./../components/About/About";
import Ourvalues from "../components/Extraaddon/Ourvalues";



const Plans = () => {
  return (
    <>
    <About3/>
    {/* <About/> */}
    <Ourvalues />
    {/* <Team /> */}
    </>
  )
}

export default Plans